import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`px-insetX py-insetY ta-max-width`};
`

export const CartContainer = styled.div`
  ${tw`lg:grid gap-x-16 items-start`};
  /* grid-template-columns: 3fr 1fr; */
  grid-template-columns: minmax(0, 62%) minmax(0, 38%);
`

export const CartSummaryWrapper = styled.div`
  ${tw`relative pt-8 lg:pt-0 border-t lg:border-t-0`};
  border-color: var(--color-grey);

  &::before {
    content: '';
    ${tw`absolute top-0 left-0 w-px h-full -ml-8 hidden lg:block`};
    background-color: var(--color-grey);
  }
`
